import type { ReadingType } from "../Components/QuestionInput/QuestionInput";
import type { Translations } from "../i18n/translations";

export type SpreadType = Exclude<ReadingType, "single" | "yes-or-no">;

export interface SpreadPositionConfig {
  key: string;
  labelKey: keyof Translations;
}

export interface SpreadConfig {
  type: SpreadType;
  nameKey: keyof Translations;
  positions: [SpreadPositionConfig, SpreadPositionConfig, SpreadPositionConfig];
}

export const SPREAD_CONFIGS: Record<SpreadType, SpreadConfig> = {
  "past-present-future": {
    type: "past-present-future",
    nameKey: "pastPresentFuture",
    positions: [
      { key: "past", labelKey: "past" },
      { key: "present", labelKey: "present" },
      { key: "future", labelKey: "future" },
    ],
  },
  relationship: {
    type: "relationship",
    nameKey: "relationshipSpread",
    positions: [
      { key: "youWant", labelKey: "youWant" },
      { key: "partnerWants", labelKey: "partnerWants" },
      { key: "heading", labelKey: "relationshipHeading" },
    ],
  },
  "you-position-potential": {
    type: "you-position-potential",
    nameKey: "youPositionPotential",
    positions: [
      { key: "you", labelKey: "youCard" },
      { key: "yourPosition", labelKey: "yourPosition" },
      { key: "yourPotential", labelKey: "yourPotential" },
    ],
  },
  "unconscious-conscious-superconscious": {
    type: "unconscious-conscious-superconscious",
    nameKey: "unconsciousConsciousSuperconscious",
    positions: [
      { key: "unconscious", labelKey: "unconscious" },
      { key: "conscious", labelKey: "conscious" },
      { key: "superconscious", labelKey: "superconscious" },
    ],
  },
  "embrace-accept-let-go": {
    type: "embrace-accept-let-go",
    nameKey: "embraceAcceptLetGo",
    positions: [
      { key: "embrace", labelKey: "embrace" },
      { key: "accept", labelKey: "accept" },
      { key: "letGo", labelKey: "letGo" },
    ],
  },
  "situation-obstacle-lesson": {
    type: "situation-obstacle-lesson",
    nameKey: "situationObstacleLesson",
    positions: [
      { key: "situation", labelKey: "theSituation" },
      { key: "obstacle", labelKey: "theObstacle" },
      { key: "lesson", labelKey: "theLesson" },
    ],
  },
};
